import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'



Vue.use(Router)

export default new Router({
  routes: [
    //   首页
    {
      id:1,
      path: '/',
      name: 'Index',
      component: Index,
      redirect:'/home',
      meta: {title:'首页'},
      id:1,
      children:[
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/components/Home'),
          meta: {title:'首页'}
        }]
      },

    //   关于我们
    {
      id:2,
      path: '/',
      name: 'Index',
      component: Index,
      redirect:'/about',
      meta: {title:'关于我们'},
      id:2,
      children:[
        {
          path: 'about',
          name: 'About',
          component: () => import('@/components/About'),
          meta: {title:'关于我们'}
        }]
      },

      //   行动使命
      {
        id:4,
        path: '/action',
        component: Index,
        redirect: '/action/younyleader',
        meta: {title:'行动使命'},
        children:[
          {
            path: 'younyleader',
            name: 'Younyleader',
            component: () => import('@/components/mission/Younyleader'),
            meta: { title: '国际青年领导力' }, 

          },
          {
            path: 'technologysharing',
            name: 'TechnologySharing',
            component: () => import('@/components/mission/TechnologySharing'),
            meta: { title: '技术共享' }, 

          },
          {
            path: 'equalwomen',
            name: 'EqualWomen',
            component:  () => import('@/components/mission/EqualWomen'),
            meta: { title: '女性平等' }, 

          },
          {
            path: 'civilized',
            name: 'Civilized',
            component:  () => import('@/components/mission/Civilized'),
            meta: { title: '文明互鉴' }, 

          },


          //   详情页**********************************
          {
            path: 'mission/missiondetails',
            name: 'MissionDetails',
            component: () => import('@/components/mission/MissionDetails'),
            meta: { title: '' }, 
            hidden: true
          },
          //   搜索页**********************************
          {
            path: 'mission/search',
            name: 'Search',
            component: () => import('@/components/Search'),
            meta: { title: '' }, 
            hidden: true
          },

          {
            path: 'titleNews',
            name: 'TitleNews',
            component: () => import('@/components/news/TitleNews'),
            meta: {title:''},
            hidden: true
          },
          {
            path: 'video',
            name: 'Video',
            component: () => import('@/components/news/Video'),
            meta: {title:''},
            hidden: true
          },
        ]
      },


            //   新闻媒体
      {
        path: '/',
        name: 'Index',
        component: Index,
        redirect:'/new',
        meta: {title:'新闻媒体'},
        id:7,
        children:[
          {
            path: 'new',
            name: 'New',
            component: () => import('@/components/news/New'),
            meta: {title:'新闻媒体'}
          },
        ]
        },




        //   品牌活动
        {
          path: '/brand',
          name: 'Index',
          component: Index,
          redirect:'/brand/vineproject',
          meta: {title:'品牌活动'},
          id:5,
          children:[
            {
              path: 'vineproject',
              name: 'VineProject',
              component: () => import('@/components/brand/VineProject'),
              meta: {title:'藤蔓计划'}, 
            },
            {
              path: 'class',
              name: 'Class',
              component: () => import('@/components/brand/Class'),
              meta: {title:'一带一路大讲堂'}, 
            },
            {
              path: 'developentforum',
              name: 'DevelopentForum',
              component: () => import('@/components/brand/DevelopentForum'),
              meta: {title:'一带一路发展论坛'}, 
            },
            {
              path: 'silkroadbridge',
              name: 'SilkRoadbridge',
              component: () => import('@/components/brand/SilkRoadbridge'),
              meta: {title:'丝路桥'}, 
            },
            {
              path: 'greendocking',
              name: 'GreenDocking',
              component: () => import('@/components/brand/GreenDocking'),
              meta: {title:'绿色产业对接会'}, 
            },
          ]
          },




//      咨询服务
        {
          path:'/server',
          component:Index,
          redirect:'/server/researchconsultion',
          meta: {title:'资讯服务'},
          id:3,
          children:[
            {
              path: 'researchconsultion',
              name: 'ResearchConsultion',
              component: () => import('@/components/server/ResearchConsultion'),
              meta: { title: '研究资讯' }, 
            },
    
            {
              path: 'trainedution',
              name: 'Trainedution',
              component: () => import('@/components/server/Trainedution'), // Parent router-view
              meta: { title: '培训教育' }, 
            },
            {
              path: 'talent',
              component: () => import('@/components/server/Talent'),
              meta: {title : '人才服务',id:14},
              name: 'Talent',
          },
          {
            path: 'interfinance',
            component: () => import('@/components/server/InterFinance'),
            meta: {title : '国际金融',id:15},
            name: 'InterFinance',
          },
          {
            path: 'commercial',
            component: () => import('@/components/server/Commercial'),
            meta: {title : '商事服务',id:16},
            name: 'Commercial',
          },
          {
            path: 'safety',
            component: () => import('@/components/server/Safety'),
            meta: {title : '安全应急',id:17},
            name: 'Safety',
          },
          {
            path: 'job',
            component: () => import('@/components/server/Job'),
            meta: {title : '工作机会',id:18},
            name: 'Job',
          },
          {
            path: 'culturalexchange',
            component: () => import('@/components/server/CulturalExchange'),
            meta: {title : '文化交流',id:19},
            name: 'CulturalExchange',
          },
          //   详情页**********************************
          {
            path: 'serverdetail',
            name: 'ServerDetail',
            component: () => import('@/components/server/ServerDetail'),
            meta: { title: '' }, 
            hidden: true
          },
          ]
        },



        //      合作需求
        {
          path: '/cooperation',
          name: 'Index',
          component: Index,
          redirect:'/cooperation/business',
          meta: {title:'合作需求'},
          id:6,
          children:[
            {
              path: 'business',
              name: 'Business',
              component: () => import('@/components/cooperation/Business'),
              meta: {title:'项目商机'}
            },
            {
              path: 'partner',
              name: 'Partner',
              component: () => import('@/components/cooperation/Partner'),
              meta: {title:'合作伙伴'}
            },
            {
              path: 'wemenber',
              name: 'Wemenber',
              component: () => import('@/components/cooperation/Wemenber'),
              meta: {title:'成为会员'}
            },
            {
              path: 'intermemenber',
              name: 'InterMemenber',
              component: () => import('@/components/cooperation/InterMemenber'),
              meta: {title:'加入会员'},
              hidden: true
            },
            {
              path: 'intervine',
              name: 'Intervine',
              component: () => import('@/components/cooperation/Intervine'),
              meta: {title:'加入藤蔓计划'}
            },
          ]
          },



        // 企业专区
        {
          path: '/business',
          name: 'Index',
          component: Index,
          redirect:'/business/project',
          meta: {title:'企业专区'},
          id:8,
          children:[
            {
              path: 'project',
              name: 'Project',
              component: () => import('@/components/business/Project'),
              meta: {title:'项目'}
            },
            {
              path: 'enterprise',
              name: 'Enterprise',
              component: () => import('@/components/business/Enterprise'),
              meta: {title:'企业'}
            },
          ]
          },

  ],
  // mode:'history',
  linkActiveClass: 'actives',
})

export const asyncRoutes = {
  
}


// WEBPACK FOOTER //
// ./src/router/index.js